import { Convert, QuantityToString } from "@pdfking/quantity"
import { DISTANCE } from "@pdfking/quantity/constants"

export const FormatDistance = (v: number, from: string, decimals = 1): string =>
  QuantityToString(Convert(v, DISTANCE, from, "cm"), undefined, { decimals })
